import * as Unicons from '@iconscout/react-unicons';
import { Link } from 'react-router-dom';
import {
  ICurriculoFullDTO,
  ICursoFullDTO,
  IProdutoEscolaFullDTO,
} from '../../../../models/happy-code-api.model';
import './product-type-table-row.styles.scss';
import useProductTypeTable from './use-product-type-table.hook';
import { TFunction } from 'i18next';

interface ProductTypeTableRowProps {
  image: string;
  url: string;
  item: ICursoFullDTO | ICurriculoFullDTO | IProdutoEscolaFullDTO;
  t: TFunction<"materiais", undefined>
}

export const ProductTypeTableRow = ({
  image,
  url,
  item,
  t
}: ProductTypeTableRowProps) => {
  const { findOutWhatDataToUse } = useProductTypeTable();

  const { descricao, negocio, duracao, quantidadeMaterial, tipoUnidade } =
    findOutWhatDataToUse(item);

  return (
    <div className="product-type-table-row">
      <div className="product-type-table-row__thumb-course-description">
        <img src={image} alt={`${descricao} thumbnail`} />
        <p className="thumb-course-description__description">{descricao}</p>
      </div>
      <div className="product-type-table-row__item">{negocio}</div>
      <div className="product-type-table-row__item">{duracao}</div>
      <div className="product-type-table-row__item">{quantidadeMaterial}</div>
      <div className="product-type-table-row__item">{tipoUnidade}</div>

      <div className="product-type-table-row__item">
        <Link
          to={url}
          className="button-primary product-type-table-row__button"
        >
          {t('materiais:seeCourse')} <Unicons.UilArrowRight />
        </Link>
      </div>
    </div>
  );
};
